import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  // Multi-layer parallax transforms
  const bgY = useTransform(scrollY, [0, 800], [0, 300]);
  const bgScale = useTransform(scrollY, [0, 800], [1.33, 1.5]);
  const bgOpacity = useTransform(scrollY, [0, 600], [0.03, 0.008]);
  const accentY = useTransform(scrollY, [0, 800], [0, 80]);
  const contentY = useTransform(scrollY, [0, 800], [0, -60]);
  const contentOpacity = useTransform(scrollY, [0, 600], [1, 0.3]);
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 py-20 bg-bg-primary overflow-hidden" data-id="element-35">
      {/* Blueprint texture background with parallax */}
      <motion.div className="absolute -inset-[20%] pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/qQtiZw2q4ZJs9LSsj3vhP1/bgMP.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      opacity: bgOpacity,
      scale: bgScale,
      y: bgY
    }} data-id="element-36" />

      {/* Subtle background accent with parallax */}
      <motion.div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-32 bg-gradient-to-b from-gold/0 via-gold/50 to-gold/0 opacity-50" style={{
      y: accentY
    }} data-id="element-37" />

      <motion.div className="max-w-4xl mx-auto text-center z-10 flex flex-col items-center" style={{
      y: contentY,
      opacity: contentOpacity
    }} data-id="element-38">
        <motion.img initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} src="https://cdn.magicpatterns.com/uploads/tm4d4ud82zMqryLRAB6zRC/BramalProject_logo.svg" alt="BRAMAL PROJECT s.r.o." className="w-full max-w-[300px] mb-16" data-id="element-39" />

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-serif font-light text-white mb-8 leading-tight tracking-wide" data-id="element-40">
          {t('hero.title')}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-16 leading-relaxed font-[200]" data-id="element-41">
          {'Navrhujeme a realizujeme projekty, kter\xE9 spojuj\xED architekturu, technologie a dlouhodobou hodnotu. Bydlen\xED, kter\xE9 odpov\xEDd\xE1 dne\u0161n\xEDm n\xE1rok\u016Fm a z\xE1rove\u0148 je p\u0159ipraven\xE9 na budoucnost.'}
        </motion.p>

        <motion.a initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} href="#about" className="inline-flex items-center justify-center px-8 py-4 border border-gold text-gold hover:bg-gold hover:text-bg-primary transition-all duration-300 uppercase tracking-widest text-sm" data-id="element-42">
          {t('hero.cta')}
        </motion.a>
      </motion.div>
    </section>;
}